import { render, staticRenderFns } from "./modalDuplicarHorario.vue?vue&type=template&id=65c44878&scoped=true"
import script from "./modalDuplicarHorario.vue?vue&type=script&lang=js"
export * from "./modalDuplicarHorario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c44878",
  null
  
)

export default component.exports